<script setup>
import { ref } from 'vue';
import VueMultiselect from 'vue-multiselect';

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    placeholder: {
        type: String,
        required: true
    },
    value: {
        type: String,
        default: ''
    },
    options: {
        type: Array,
        required: true
    },
    error: {
        type: String,
        default: ''
    }
});

const value = ref(props.value);
</script>

<template>
    <div class="">
        <VueMultiselect
            v-model="value"
            class="tw-mb-4"
            :class="props.error && 'error'"
            :placeholder="props.placeholder"
            type="text"
            :name="props.name"
            :options="props.options"
            :searchable="false"
            :close-on-select="true"
            :allow-empty="false"
            :show-labels="false"
            @select="$emit('update', $event)"
        />
        <p v-if="props.error" class="tw-text-sm tw--mt-2 tw-mb-4 tw-text-red tw-block">
            {{ props.error }}
        </p>
    </div>
</template>

<style>
@import 'vue-multiselect/dist/vue-multiselect.css';

.multiselect__tags {
    @apply tw-border-[#d8d8d8] tw-rounded-none tw-border-2;
    min-height: 50px;
}

.error > .multiselect__tags {
    @apply tw-border-red;
}

.multiselect__select {
    height: 45px;
}

.multiselect__placeholder,
.multiselect__single {
    @apply tw-pt-[6px] tw-text-black tw-pl-2 tw-text-base;
}

.multiselect__option--highlight,
.multiselect__option--selected,
.multiselect__option--highlight:hover,
.multiselect__option--selected:hover {
    @apply tw-bg-grey-200 tw-text-black !important;
}
</style>
